import basketProduct from '@/modules/basket/components/product/index.vue'
import {mapActions, mapMutations, mapGetters} from "vuex";

export default {
    name: 'basket',
    components: {
        basketProduct
    },
    data() {
        return {}
    },
    created() {
        console.log(this.getCurrentOrder);
        // if (!this.isAuthenticated) {
        //     this.$router.push({name: 'home'})
        // }
    },
    methods: {
        ...mapMutations({
            resetBasket:'order/RESET_BASKET'
        })
    },
    computed: {
        ...mapGetters({
            getCurrentOrder: 'order/getCurrentOrder',
            isAuthenticated: 'auth/isAuthenticated'

        }),
        getTotalPrice() {
            let arr = []
            this.getCurrentOrder.forEach(product => {
                arr.push(product.sum)
            })
            let sum = arr.reduce((a, b) => a + b, 0)
            return sum
        }
    }

}
